import { BaseApiModel } from './BaseApiModel';

export class StatusStorage extends BaseApiModel {
    public name: string;
    public description: string;
    public createdAt: Date;
    public deletedAt: Date;
}
